import React, { useState } from "react";
import axios from "axios";
import { Phone, Lock, Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function OpsLogin({ onLogin }) {
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const res = await axios.post(
        `${API_URL}/api/ops/login`,
        { phone, pin, remember_me: rememberMe },
        { withCredentials: true }
      );
      const auth = res.data;
      // Persist metadata + JWT in sessionStorage so the X-Ops-Auth header
      // survives page refreshes when the HttpOnly cookie is dropped (Safari/ITP,
      // cross-site doozygo.com → API setups). Cookie remains primary.
      const meta = { name: auth.name, phone: auth.phone, role: auth.role, token: auth.token || "" };
      sessionStorage.setItem("doozygo_ops_meta", JSON.stringify(meta));
      onLogin(meta);
    } catch {
      setError("Invalid phone or PIN");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1E1B4B] to-[#312e81] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_party-in-2hrs/artifacts/47ayyz1k_SUMIT%20DOOZYGO%20LOGO%20-%20AUG%202023.png" alt="DoozyGo" className="h-20 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#1E1B4B] font-['Outfit']">DoozyGo Ops</h1>
          <p className="text-sm text-[#94a3b8] mt-1">Field team portal</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <Phone size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94a3b8]" />
            <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone number" className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:border-[#E83E8C] outline-none text-sm" data-testid="ops-login-phone" />
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94a3b8]" />
            <input value={pin} onChange={e => setPin(e.target.value)} placeholder="4-digit PIN" type="password" maxLength={4} className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:border-[#E83E8C] outline-none text-sm" data-testid="ops-login-pin" />
          </div>
          {error && <p className="text-red-500 text-xs text-center">{error}</p>}
          <label className="flex items-center gap-2 select-none cursor-pointer text-xs text-[#475569]" data-testid="ops-login-remember-me-label">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={e => setRememberMe(e.target.checked)}
              className="w-4 h-4 rounded border-gray-300 accent-[#E83E8C]"
              data-testid="ops-login-remember-me"
            />
            Remember me on this device for 7 days
          </label>
          <button type="submit" disabled={loading} className="w-full py-3 bg-gradient-to-r from-[#E83E8C] to-[#FF9F1C] text-white rounded-xl font-bold text-sm hover:shadow-lg transition-all disabled:opacity-50 flex items-center justify-center gap-2" data-testid="ops-login-btn">
            {loading ? <Loader2 size={16} className="animate-spin" /> : null} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
